class AccountSettings.TicketValidationRulesView extends Backbone.View
  template: JST['backbone/templates/account_settings/ticket_validation_rules/ticket_validation_rules']
  className: 'ticket-validation-rules'

  events:
    'click #save-button': '_save'

  initialize: ->
    @ticketValidationRules = new AccountSettings.TicketValidationRules()

  render: ->
    @$el.html(@template)
    @ticketValidationRules.fetch().done(@_onFetchDone)
    @

  _onFetchDone: =>
    @ticketValidationRulesList = new AccountSettings.AttributesValidationRuleListView
      type: 'Ticket'
      attributeValidationRulesCollection: @ticketValidationRules.get('ticket_attributes')
    @userProfileValidationRulesList = new AccountSettings.AttributesValidationRuleListView
      type: 'Profile'
      attributeValidationRulesCollection: @ticketValidationRules.get('user_profile_attributes')
    ticketValidationRulesLists = @$el.find('#ticket-validation-rules-lists')
    ticketValidationRulesLists.append(@ticketValidationRulesList.render().el)
    ticketValidationRulesLists.append(@userProfileValidationRulesList.render().el)

  _save: ->
    saveButton = @$el.find('#save-button')
    saveButton.prop('disabled', true)
    saveButton.addClass('saving')
    @ticketValidationRules.save().always((response) ->
      if response.status == 200
        window.showSuccess(I18n.t('account_settings.ticket_validation_rules.successful_save'))
      else
        showError(I18n.t('generic_error_message'))
      saveButton.prop('disabled', false)
      saveButton.removeClass('saving')
    )
